import { Card } from "../UI/Card";
import { LucideIcon } from "lucide-react";

interface QuickActionCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  gradient: string;
  onClick?: () => void;
}

export const QuickActionCard = ({
                                  icon: Icon,
                                  title,
                                  description,
                                  gradient,
                                  onClick
                                }: QuickActionCardProps) => {
  return (
    <Card
      className={`${gradient} p-6 cursor-pointer hover:scale-[1.02] transition-transform border-0 text-white`}
      onClick={onClick}
    >
      <div className="flex items-start gap-4">
        <div className="p-3 bg-white/20 rounded-xl backdrop-blur-sm">
          <Icon className="h-6 w-6" />
        </div>
        <div className="flex-1">
          <h3 className="font-bold text-lg mb-1">{title}</h3>
          <p className="text-sm text-white/90">{description}</p>
        </div>
      </div>
    </Card>
  );
};
